import React, { useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { AutoComplete, Input, message, Button } from 'antd';
import axiosInstance from '../../utils/axios';
import { useDevice } from '../../hooks';
import { useNavigate, Link } from 'react-router-dom';
import { FormatVND } from '../../utils/format';

const AutoCompleteCustom = () => {
  const { isMobile } = useDevice();
  const navigate = useNavigate();
  const [options, setOptions] = useState([]);
  const [keyword, setKeyword] = useState("");

  const fetchSuggestions = async (query) => {
    if (!query || query.trim() === "") {
      setOptions([]);
      return;
    }

    try {
      const res = await axiosInstance.get("/search-page/getAllSearchPage", {
        params: { keyword: query, page: 1, pageSize: 12 }
      });
      const data = res?.data?.data || [];
      
      const suggestions = data.map((item) => ({
        key: item.product_id,
        value: item.product_name, 
        slug: item.product_slug,   
        label: (
          <Link 
            to={`/san-pham/${item.product_slug}`} 
            className='flex items-center text-black py-2 w-full h-full' 
            onClick={() => { setOptions([]); setKeyword(""); }}
          >
            <img 
              src={JSON.parse(item?.product_image)?.filter((i) => i.type === 'image')?.[0]?.data} 
              className={`${isMobile ? "w-[35px] h-[35px]" : "w-[45px] h-[45px]"} rounded-md object-cover flex-shrink-0`}
              alt={item.product_name}
              onError={(e) => { e.target.src = "https://placehold.co/45x45?text=Product"; }}
            />
            <div className="pl-3 overflow-hidden">
              <p className='font-semibold truncate text-[13px] leading-tight mb-0.5'>{item?.product_name}</p>
              <p className="text-[11px] text-blue-600 font-medium">{FormatVND(item?.product_price)}</p>
            </div>
          </Link>
        ),
      }));
      setOptions(suggestions);
    } catch (error) {
      console.error("Fetch search error:", error);
    }
  };

  const onSelect = (value, option) => {
    if (option?.slug) {
      // For keyboard selection support
      navigate(`/san-pham/${option.slug}`);
      setKeyword("");
      setOptions([]);
    }
  };

  const handleSearch = () => {
    const val = keyword.trim();
    if (val !== "") {
      navigate(`/tim-kiem/${encodeURIComponent(val)}`);
      setOptions([]);
      setKeyword("");
    } else {
      message.info("Vui lòng nhập từ khóa bạn muốn tìm kiếm!");
    }
  };

  const onKeywordChange = (e) => {
    const value = e.target.value;
    setKeyword(value);
    fetchSuggestions(value);
  };

  return (
    <div className="w-full relative search-container-custom">
      <AutoComplete
        popupMatchSelectWidth={isMobile ? 280 : 600}
        className='w-full'
        options={options}
        onSelect={onSelect}
        value={keyword}
        defaultActiveFirstOption={false}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            handleSearch();
          }
        }}
      >
        <Input 
          size="large" 
          placeholder="Bạn đang tìm kiếm sản phẩm nào?" 
          value={keyword}
          onChange={onKeywordChange}
          prefix={<SearchOutlined className="text-gray-400 mr-1" />}
          suffix={keyword ? <span className="cursor-pointer text-gray-300 hover:text-gray-500" onClick={() => setKeyword("")}>✕</span> : null}
          addonAfter={!isMobile && (
            <Button type="primary" className="h-full rounded-r-lg" onClick={handleSearch}>
              Tìm kiếm
            </Button>
          )}
          className="search-input-refinded"
        />
      </AutoComplete>
    </div>
  );
};

export default AutoCompleteCustom;